import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { withRouter } from "react-router-dom";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { IoSearchSharp } from "react-icons/io5";
import { Async } from "react-select";


const styles = theme => ({

});

class UserLists extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: ''
        };
    }

    async componentDidMount() {

    }

    gotoWorkshop = item => {
        this.props.history.push({
            pathname: "/Workshoplist",
            SFID: item.sfid,
            Type: this.props.type,
            count: 0,
        });
    };

    handleInputChange = (e) => {
        var value = e.target.value.toUpperCase();
        this.setState({
            searchTerm: value
        });
    };

    openPDF = (value) => {
        window.open(value, '_blank');
    };

    render() {
        const { listitems } = this.props;
        const { loading, searchTerm } = this.state;

        return (
            <Fragment>
                <div className='fevicyrlContent__search_bar'>
                    <input
                        type="text"
                        placeholder="Search User"
                        // value={searchTerm}
                        onChange={this.handleInputChange}
                        className='fevicyrlContent__searchInput w-100'
                    />
                    <button onClick={this.handleSearch} className='fevicyrlContent__searchButton'>
                        <IoSearchSharp className='fevicyrlContent__searchButtonIcon' />
                    </button>
                </div>

                <List>
                    {listitems.filter((item) => {
                        return searchTerm.toUpperCase() === '' ? item :
                            item.name.toUpperCase().includes(searchTerm) || item.sfid.toUpperCase().includes(searchTerm)
                    }).map((item, index) => {
                        return (
                            <Paper key={item.id}>
                                <Grid
                                    container
                                    spacing={8}
                                    alignItems="center"
                                    justify="space-between"
                                >
                                    <Grid
                                        item
                                        xs={6}
                                        style={{ padding: 15 }}
                                        onClick={() => this.gotoWorkshop(item)}
                                    >
                                        <Typography align="left" variant="body2" component="" style={{ fontSize: 12 }}>
                                            {item.name}
                                        </Typography>
                                        <Typography align="left" variant="caption" component="" style={{ fontSize: 12 }}>
                                            {item.sap_code__c ? item.sap_code__c : item.cmdi_code__c}
                                        </Typography>
                                        <Typography align="left" variant="caption" component="p">
                                            {item.end_date_time__c}
                                        </Typography>
                                    </Grid>
                                    {this.props.type == 'ETTC' ?
                                        <Grid item xs={6}>
                                            <Grid container alignItems="center" justify="center">
                                                {/* <Grid item xs={6} md={6} style={{ paddingLeft: 15 }}>
                                                    <Typography align="center" variant="body2">
                                                        <a href="#" onClick={() => {
                                                            this.openPDF(item.ettc_document__c)
                                                        }} target="_blank" rel="noopener noreferrer"> View  </a>
                                                    </Typography>
                                                </Grid> */}
                                                <Grid item xs={6} md={6} style={{ paddingRight: 15 }}>
                                                    <Typography align="center" variant="body2">
                                                        <a href={item.ettc_download__c} download="filename.pdf">
                                                            Download
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid> :
                                        <>
                                            <Grid item xs={6}>
                                                <Typography align="right" style={{ paddingRight: 10 }} zeroMinWidth >
                                                    <div className="d-flex justify-content-end">
                                                        <div className="align-self-center">{this.props.type}</div>
                                                    </div>
                                                </Typography>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                                <Divider />
                            </Paper>
                        );
                    })}
                </List>
            </Fragment>
        );
    }
}

UserLists.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(UserLists));